module.exports = __webpack_public_path__ + "static/media/calendar.b85fda29.svg";